module.exports = __webpack_public_path__ + "static/media/newsletter-may-2021-paschal-divine-liturgy.500caceb.jpg";